import { useTranslation } from 'react-i18next';

import AiStarsSvg from '@/shared/assets/ai-stars.svg?react';
import AiText from '@/shared/assets/ai-text.svg?react';
import Cara from '@/shared/assets/cara.png';
import WeirdBgShapes from '@/shared/assets/weird-bg-shapes.svg?react';
import { Avatar, AvatarImage } from '@/shared/components/ui/avatar';

export const AiDashboardCard = () => {
  const { t } = useTranslation('overview', {
    keyPrefix: 'OverviewPage.aiCard',
  });

  return (
    <div className="relative flex flex-col gap-8 overflow-hidden rounded-xl bg-light-container p-6">
      <WeirdBgShapes className="absolute bottom-0 right-0 h-full object-contain opacity-25" />
      <div className="flex flex-row items-center gap-3">
        <Avatar>
          <AvatarImage src={Cara} />
        </Avatar>
        <div className="flex flex-col">
          <div className="flex flex-row items-center">
            <span className="mr-2 text-2xl font-semibold">{t('name')}</span>
            <AiStarsSvg className="size-6" />
            <AiText className="size-8" />
          </div>
          <span className="text-3xs text-primary-shade-grey-500">
            {t('title')}
          </span>
        </div>
      </div>
      <span className="text-xl leading-[58px] tracking-[-0.4px]">
        {t('description')}
      </span>
    </div>
  );
};
